import React from "react";
import PageLayout from "../components/PageLayout";
import TeamMember from "../components/TeamMember";
import { teamMembers } from "../data/team";

const Team: React.FC = () => {
    return (
        <PageLayout title="Unser Team">
            {teamMembers.map((member, index) => (
                <TeamMember key={member.name} member={member} reverse={index % 2 === 1} />
            ))}
        </PageLayout>
    );
};

export default Team;
